var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 30.000000 30.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 275 c-23 -22 -25 -31 -25 -125 0 -94 2 -103 25 -125 22 -23 31 -25 125 -25 94 0 103 2 125 25 23 22 25 31 25 125 0 94 -2 103 -25 125 -22 23 -31 25 -125 25 -94 0 -103 -2 -125 -25z m78 -102 l22 -38 3 38 c3 29 7 37 20 35 10 -2 19 -16 23 -33 l5 -30 20 32 c18 32 34 40 47 27 4 -4 -1 -19 -10 -35 -16 -26 -16 -29 0 -47 9 -10 17 -22 17 -25 0 -13 -38 -7 -50 8 -7 8 -16 15 -21 15 -5 0 -9 -7 -9 -15 0 -23 -44 -18 -68 8 -27 28 -52 78 -46 89 10 16 25 7 47 -29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.f98eed0808b5b726f2072ecf5193bbbe.svg";
export { ForwardRef as ReactComponent };